(function(angular) {
    'use strict';

    angular.module('GorillaBoy.Dashboard')
    .config(['$routeProvider', function($routeProvider) {
        var TEMPLATE_LAYOUT = './assets/partials/app/layout.html';
        function resolveUserInfo () {
            return ['$q', 'SessionManager', 'AuthService', '$location', function ($q, SessionManager, authService, $location) {
                var refreshUserInfo = false;
                var deferred = $q.defer();
                authService.getUserInfo(refreshUserInfo)
                .then(function (user) {
                    if (user && user.MinimalUser) {
                        $location.url('/shared').replace();
                        deferred.resolve({error: 'Guest users cannot view this page.'});
                    } else {
                        deferred.resolve(user);
                    }
                });

                return deferred.promise;
            }];
        }
        $routeProvider
            .when('/dashboard', {
                auth: true,
                templateUrl: TEMPLATE_LAYOUT,
                controller: 'DashboardController',
                resolve: {
                    userInfo: resolveUserInfo(),
                    featureMap: ['FeatureManagerService', function(featureManagerService) {
                        return featureManagerService.getEnabledFeatureMap();
                    }]
                }
            });
    }]);
}(angular));